import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/faqAnswer";

export const getFaqAnswers = gql`
  query getFaqAnswers {
    faqAnswers: faq_answers {
      ...allFaqAnswersFields
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/queries/getFaqAnswers.js